import { render, staticRenderFns } from "./not-authorized.vue?vue&type=template&id=2b432c89&"
import script from "./not-authorized.vue?vue&type=script&lang=js&"
export * from "./not-authorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports